<template>
  <div>
    <cover :pageData="pageData"></cover>
    <div class="page">
      <div
        class="title"
        v-for="item in categoryList"
        :key="item.id"
        v-show="tabIndex == item.id"
      >
        <div class="cn_title">{{ item.name }}</div>
        <div class="en_title">{{ item.englishName }}</div>
      </div>
      <div class="content">
        <div class="content_left">
          <div class="options_title">按业务分类</div>
          <div class="options">
            <div
              class="base_front"
              v-for="item in categoryList"
              :key="item.id"
              :class="tabIndex == item.id ? 'blue' : 'gray'"
              @click="chooseOption(item)"
            >
              {{ item.name }}
              <div class="option_img" v-show="tabIndex != item.id">
                <img src=../assets/img/24x24_product_right_un@2x.png>
              </div>
              <div class="option_img" v-show="tabIndex == item.id">
                <img src=../assets/img/24x24_product_right@2x.png>
              </div>
            </div>
          </div>
          <div class="project_btn" @click="toPerformance">
            <img
              class="project_btn_img"
              src="../assets/img/240x82_button_performance@2x.png"
            />
          </div>
        </div>
        <div class="content_right">
          <div class="noneBox" v-show="!projectList">
<!--            <img src="../assets/img/240x240_bg_default@2x.png" alt="" />-->
            <div class="noneFront">很抱歉，暂无更多内容~</div>
          </div>
          <div class="projects">
            <projectBox
              v-for="item in projectList"
              :key="item.id"
              :project="item"
              @click.native="toBuildDetail(item)"
            >
            </projectBox>
          </div>
        </div>
      </div>
    </div>
    <div class="pag" v-show="tabIndex != 4 && projectList">
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getConstructionPage, getCasePage } from "@/server/https.js";
import cover from "../components/cover.vue";
import projectBox from "../components/projectBox.vue";
export default {
  name: "",
  tabIndex: 0,
  components: {
    cover,
    projectBox,
  },
  data() {
    return {
      tabIndex: 0,
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      categoryList: [],
      projectList: [],
      currentPage: 1, // 当前页码默认值为1
      pageSize: 6, // 每页显示条数默认值为10
      total: 0, // 数据总数
    };
  },
  mounted() {
    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 6) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
    getConstructionPage().then((res) => {
      res.data.body.categoryList.sort((a, b) => a.sort - b.sort);
      this.tabIndex = res.data.body.categoryList[0].id;
      this.categoryList = res.data.body.categoryList;
      getConstructionPage({ categoryId: this.tabIndex,pageNo: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.total = res.data.body.page.count;
        res.data.body.page.list.sort((a, b) => a.sort - b.sort);
        this.projectList = res.data.body.page.list;
      });
    });
  },
  methods: {
    //发请求获取tradeList数据
    chooseOption(item) {
      this.currentPage=1;
      this.tabIndex = item.id;
      if (item.type != "2") {
        this.getList();
      } else {
        this.getCaseList();
      }
    },
    //获取工程案例
    getCaseList() {
      getCasePage({ pageNo: this.currentPage, pageSize: this.pageSize }).then(
        (res) => {
          if (res.data.body.findList.list) {
            res.data.body.findList.list.sort((a, b) => a.sort - b.sort);
          }
          this.projectList = res.data.body.findList.list;
          this.total = res.data.body.findList.count;
        }
      );
    },
    getList() {
      getConstructionPage({
        categoryId: this.tabIndex,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.data.body.page.list) {
          res.data.body.page.list.sort((a, b) => a.sort - b.sort);
        }
        this.projectList = res.data.body.page.list;
        this.total = res.data.body.page.count;
      });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      if (this.tabIndex == undefined) {
        this.getCaseList();
      } else {
        this.getList();
      }
    },
    toPerformance() {
      this.$router.push({
        name: "performance",
      });
    },
    toBuildDetail(item) {
      if (this.tabIndex == undefined) {
        this.$router.push({
          name: "projectCase",
          query: { id: item.id },
        });
      } else {
        this.$router.push({
          name: "buildDetail",
          query: { id: item.id },
        });
      }
    },
  },
};
</script>

<style scoped>
.page {
  /* display: flex; */
  /* justify-content: center; */
  position: relative;
  margin: auto;
}

.content {
  display: flex;
  margin-top: 180px;
  justify-content: center;
}

.content_left {
  overflow: hidden;
  /* display: flex; */
  width: 230px;
  margin-bottom: 20px;
  margin-left: 100px;
  /* height: 300px; */
  /* justify-content: start; */
}

.content_right {
  width: 1200px;
  margin-left: 20px;
}

.title {
  display: flex;
  justify-content: center;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489d;
  margin-top: 56px;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #c8d4e1;
  margin-top: 56px;
}

.options {
  position: relative;
  background-color: #f7f8fa;
}

.options_title {
  width: 100%;
  padding: 10px;
  text-align: start;
  padding-left: 20px;
  line-height: 50px;
  background-color: #13489d;
  font-size: 22px;
  font-weight: bold;
  color: #ffffff;
}

.base_front {
  display: flex;
  /* padding-left: 10px; */
  font-size: 16px;
  font-weight: 500;
  padding: 20px 0 20px 20px;
  border-bottom: 2px dashed #f7f8fa;
}

.gray {
  color: #333333;
}

.blue {
  color: #13489d;
}

.base_front:hover {
  cursor: pointer;
}

.option_img {
  position: absolute;
  right: 20px;
  width: 20px;
  height: 20px;
}

.option_img img {
  width: 100%;
  height: 100%;
}

.pag {
  float: right;
  margin-bottom: 40px;
  margin-right: 200px;
}

.project_btn {
  width: 230px;
}

.project_btn:hover {
  cursor: pointer;
}

.project_btn_img {
  width: 100%;
  height: 100%;
}

.projects {
  display: flex;
  flex-wrap: wrap;
}
.noneBox {
  width: 25rem;
  height: 22rem;
  margin: auto;
}
.noneBox img {
  width: 100%;
  height: 100%;
}
.noneFront {
  text-align: center;
  margin-left: 34px;
  font-size: 16px;
}
</style>
